// extracted by mini-css-extract-plugin
export default {"text":"Projects_text__CCBq5","Projects":"Projects_Projects__EFmAR","titleContainer":"Projects_titleContainer__2idya"};